import React from 'react'
import { useCityviseApartment } from '../../assets/api/useMarketingExecutive'
import CommonTermAndCondtion from '../commonfile/CommonTermAndCondtion'
import useAuthStore from '../../store/useAuthStore'

const NewTCManager = () => {
    const { user } = useAuthStore()
    const { data: CityApartmentList, isLoading: isCityApartmentListLoading } = useCityviseApartment({ city_name: user?.city })

    return (
        <CommonTermAndCondtion apartmentRow={CityApartmentList?.data} isloadingApartment={isCityApartmentListLoading} />
    )
}

export default NewTCManager